const API = {
  POST_CREATE_ENT_ACC: {
    path: '/ent-account/create',
    method: 'POST',
  },

};
export default API;
